import React from "react";
import { Link } from "react-router-dom";
import { StrongText } from "../common";

export default function WhyCatalyzeSection({ data, onBookSession, className = "" }) {
  if (!data) return null;

  const extraClassName = className || data.className || "";
  const cards = Array.isArray(data.cards) ? data.cards : [];
  const introParagraphs = Array.isArray(data.paragraphs)
    ? data.paragraphs
    : data.paragraphs
      ? [data.paragraphs]
      : Array.isArray(data.description)
        ? data.description
        : data.description
          ? [data.description]
          : [];

  return (
    <section className={`why-catalyze-section ${extraClassName}`.trim()}>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-7">
            <div className="why-catalyze-section-intro text-center">
              <span className="main-title">{data.eyebrow}</span>
               {data.title && <h2 className="heading text-capitalize">{data.title}</h2>}
              {introParagraphs.length > 0 && (
                <div className="why-catalyze-section-paragraphs">
                  {introParagraphs.map((paragraph, index) => (
                    <p key={`${paragraph}-${index}`}>
                      <StrongText>{paragraph}</StrongText>
                    </p>
                  ))}
                </div>
              )}
              {data.button &&
                (data.buttonLink ? (
                  <Link className="default-btn" to={data.buttonLink}>  {data.button}  </Link>
                ) : onBookSession ? (
                  <button   type="button" className="default-btn"  onClick={onBookSession} >
                    {data.button}
                  </button>
                ) : null)}
            </div>
          </div>
        </div>
        {cards.length > 0 && (
          <div className="row why-catalyze-cards">
            {cards.map((card) => (
              <div className="col-lg-4 col-md-6" key={card.title}>
                <article className="why-catalyze-card">
                  {(card.image || card.icon) && (
                    <span className="why-catalyze-card-icon" aria-hidden="true">
                      {card.image ? (
                        <img
                          src={card.image}
                          alt="Vision"
                          className="why-catalyze-card-icon-image"
                        />
                      ) : (     <i className={card.icon} />  )}
                    </span>
                  )}
                  <h3>{card.title}</h3>
                  <p>
                    <StrongText>{card.description}</StrongText>
                  </p>
                </article>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
